import { render } from "./BadgeHold.vue?vue&type=template&id=38f0f770&scoped=true"
const script = {}

import "./BadgeHold.vue?vue&type=style&index=0&id=38f0f770&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38f0f770"]])

export default __exports__